// We use a non shadow DOM Web Component here, since we need to support legacy embeds and new embeds.
// So it is crucial to share the CSS for a seamless functionality.
class UtInternalEmbed extends HTMLElement {
  static observedAttributes = ["data-config"];

  constructor() {
    super();
  }

  connectedCallback() {
    const elementID = this.getAttribute("id");
    console.log("Custom element internal-embed "+elementID+" added to page.");
  }

  stripHtmlLinkTags(caption) {
    const urlPattern = /<a\s+href="([^"]*)"([^<]*)?>([^<]*)<\/a>/g;
    const urls = caption.matchAll(urlPattern);


    if (!urls) {
      return caption;
    }

    let htmlLinks = caption;

    for (const url of urls) {
      if (url.length > 3) {
        htmlLinks = htmlLinks.replace(url[0], url[3]);
      }
    }

    return htmlLinks;
  }

  stripHtmlLinks(caption) {
    caption = this.stripHtmlLinkTags(caption);
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    const urls = caption.match(urlPattern);

    if (!urls) {
      return caption;
    }

    let htmlLinks = caption;

    urls.forEach(url => {
      const toReplace = " (" + url;
      htmlLinks = htmlLinks.replace(toReplace, '');
    });

    return htmlLinks;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    const config = JSON.parse(newValue);
    let embedWrapper = document.createElement('div');
    if (config.title === undefined) {
      this.innerHTML = '';
      return;
    }

    config.cleanImgCaption = this.stripHtmlLinks(config.imgCaption);
    config.cleanImgTitle = this.stripHtmlLinks(config.imgTitle);

    if(config.type === 'Internal') {
      embedWrapper = this.getInternalEmbed(embedWrapper, config);
    }
    if (config.type === 'Recipe') {
      embedWrapper = this.getRecipeEmbed(embedWrapper, config);
    }

    this.appendChild(embedWrapper);
  }

  getInternalEmbed(embedWrapper, config){
    let premium = '';
    if (config.isPremium) {
      premium = '<span class="ut-premium--name related-overview fs12 fl-left roboto fwb"><span class="ut-premium--name home d-ibl"><em><strong>Mein</strong>Utopia</em></span></span>';
    }

    embedWrapper.innerHTML = `<a title="${config.title}" href="${config.feed}" class="ana_embed_ut_link_internal">
        <div class="teaser link-embed alignleft mb20">
        <figure class="" data-attachment-id="${config.attachmentId}">
        <div class="aspect ratio-15-7">
            <img style="object-fit: cover;" loading="lazy" fetchpriority="high" decoding="async" class="utimgrszr" width="360" height="169" src="${config.imgSrc}" title="${config.cleanImgTitle}" alt="${config.imgAlt}">
        </div>
      <figcaption>${config.cleanImgCaption}</figcaption></figure> <div class="h3">
        ${premium}
        ${config.title}</div>
      <div class="content">
        <p class="copy fs14 mb5">${config.description}</p>
        <p class="txt-right mb10"><span class="link-bb">Weiterlesen</span></p>
      </div>
    </div>
    </a>`;

    return embedWrapper;
  }

  getRecipeEmbed(embedWrapper, config){

    let vegan = '';
    if (config.isVegan) {
      vegan = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 15.685"><title>Vegan</title><path d="M6.719,14.917V10.734A8.056,8.056,0,0,1,2.158,8.7C-.281,6.26.011,2.014.011,2.014s4.245-.292,6.684,2.147c2.1,2.1,2.176,5.552,2.156,6.46,0,.007,0,.014,0,.02v4.276c0,.589-.477.767-1.066.767S6.719,15.506,6.719,14.917ZM8.133,4.159a7.1,7.1,0,0,1,.562-1.077A5.837,5.837,0,0,1,9.478,2.1a5.745,5.745,0,0,1,.767-.641,6.649,6.649,0,0,1,.838-.5A8.537,8.537,0,0,1,12.826.332,11.184,11.184,0,0,1,14.419.059C14.906.01,15.314,0,15.57,0s.418.01.42.011h0c0,.028.017.284.007.683a12,12,0,0,1-.162,1.682A9.493,9.493,0,0,1,15.227,4.5,7.059,7.059,0,0,1,14.67,5.56a5.827,5.827,0,0,1-.772.962,5.831,5.831,0,0,1-.974.78,7.082,7.082,0,0,1-1.071.56,9.547,9.547,0,0,1-2.148.6A8.657,8.657,0,0,0,8.133,4.159Z" fill="#006c16"/></svg><span class="ml-2 fs12 text-opacity-80">Vegan</span>';
    }

    // Create Rating Section
   let ratingStars = '';
    // Filled Stars
    for (let counter = 0; counter < config.rating.average; counter++) {
      ratingStars += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style="fill:#b91e27;"><path d="M7.2 1.5a1 1 0 0 1 1.6 0l1.9 3a1 1 0 0 0 .6.4l3.4.8a1 1 0 0 1 .6 1.6L13 10a1 1 0 0 0-.3.7l.3 3.5a1 1 0 0 1-1.3 1l-3.3-1.4a1 1 0 0 0-.8 0l-3.3 1.4a1 1 0 0 1-1.3-1l.3-3.5A1 1 0 0 0 3 10L.7 7.3a1 1 0 0 1 .6-1.6L4.7 5a1 1 0 0 0 .6-.4Z"></path></svg>';
    }
    // Empty Stars
    for (let counter = 1; counter <= (5 - config.rating.average); counter++) {
      ratingStars += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style="fill:hsl(0deg 0% 50%);"><path d="M7.2 1.5a1 1 0 0 1 1.6 0l1.9 3a1 1 0 0 0 .6.4l3.4.8a1 1 0 0 1 .6 1.6L13 10a1 1 0 0 0-.3.7l.3 3.5a1 1 0 0 1-1.3 1l-3.3-1.4a1 1 0 0 0-.8 0l-3.3 1.4a1 1 0 0 1-1.3-1l.3-3.5A1 1 0 0 0 3 10L.7 7.3a1 1 0 0 1 .6-1.6L4.7 5a1 1 0 0 0 .6-.4Z"></path></svg>';
    }
    const ratingCount = `(${config.rating.count || '0'}` + config.rating.count === '1' ? ' Bewertung)' : ' Bewertungen)';

    embedWrapper.innerHTML = `<a title="${config.title}" href="${config.feed}" class="ana_embed_ut_link_internal">
        <div class="teaser link-embed alignleft mb20">
        <figure class="" data-attachment-id="${config.attachmentId}">
          <div class="aspect ratio-15-7">
              <img style="object-fit: cover;" loading="lazy" fetchpriority="high" decoding="async" class="utimgrszr" width="640" height="300" src="${config.imgSrc}" title="${config.cleanImgTitle}" alt="${config.imgAlt}">
          </div>
          <figcaption>${config.cleanImgCaption}</figcaption>
        </figure>
        <div class="h3">
          ${config.title}
          ${vegan}
        </div>
        <div class="flex flex-wrap fs12 mb20" id="recipe-details">
            <div class="flex mr-7" id="label-rating">
              ${ratingStars}
              <span class="ml5 text-opacity-80">${ratingCount}</span>
            </div>
            <div class="flex mr-7" id="label-time">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><circle cx="8" cy="8" r="7" fill="none" stroke="#ddd" stroke-width="2"/><path d="M8 3.7V8l2.1 2.1" fill="none" stroke="#ddd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                <span class="ml5 text-opacity-80">${config.totalCookingTime} Min.</span>
            </div>
        </div>
        <div class="content">
          <p class="txt-right mb10"><span class="link-bb">Weiterlesen</span></p>
        </div>
    </div>
    </a>`;

    return embedWrapper;
  }

}


export default UtInternalEmbed;
